<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("Fnborders") }}</div>
      <div class="mt-3 mb-4">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :multiple="true"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="date"
                  v-on:click="date = null"
                  type="button"
                >
                  ×
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  typeable
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="date ? 'active' : ''">{{
                  $t("From Date")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="toDate"
                  v-on:click="toDate = null"
                  type="button"
                >
                  ×
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">{{
                  $t("To Date")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedBookingSource && selectedBookingSource.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("bookingsource", 1) }}</label
              >
              <b-dropdown
                :text="selectedBookingSource || 'Select Booking Source'"
                name="selectbookingsource"
                id="selectbookingsource"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  @click="
                    onSelect(
                      $event,
                      { bs_source: 'All', bs_id: 0 },
                      'BookingSource'
                    )
                  "
                  >All</b-dropdown-item
                >
                <b-dropdown-item
                  href="#"
                  v-for="(booking, bookingIndex) in BookingSourceList"
                  :key="bookingIndex"
                  @click="onSelect($event, booking, 'BookingSource')"
                  >{{ booking.bs_source }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedStatus && selectedStatus.length > 0 ? 'shift-up' : ''
                "
                >{{ $tc("status", 1) }}</label
              >
              <b-dropdown
                :text="selectedStatus"
                name
                id
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(status, statusIndex) in fnbOrderStatus"
                  :key="statusIndex"
                  v-on:click="onSelect($event, status, 'OrderStatus')"
                  >{{ status }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent="GetTransactionList('N', 'N')"
              class="btn-blue-lg w-100"
            >
              {{ $tc("fetch") }}
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex">
        <div
          v-if="transactionList.length > 0"
          class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center gap-3"
        >
          <a
            target="_blank"
            @click="GetTransactionList('Y', 'N')"
            title="Download as Excel"
            download
            class="download-link mr-2"
          >
            <img src="@/assets/img/icons/excel.svg" height="20" width="20" />
          </a>
          <a
            target="_blank"
            @click="GetTransactionList('N', 'Y')"
            title="Download as PDF"
            download
            class="download-link"
          >
            <img src="@/assets/img/icons/pdf.svg" height="20" width="20" />
          </a>
        </div>

        <div
          v-if="transactionList && transactionList.length > 0"
          class="text-right mb-3"
        >
          <b-dropdown
            id="listview"
            variant="outline-blue"
            class="minimal-dropdown"
          >
            <template v-slot:button-content>
              {{ selectedvalue }} / {{ rows }}
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
      <div class="swc-report">
        <div class="swc-report-card">
          <table class="swc-report-table">
            <thead>
              <tr>
                <th>Order Code</th>
                <th>Order Type</th>
                <th>Pickup / Delivery Time</th>
                <th>Cinema</th>
                <th>Screen</th>
                <th>Movie</th>
                <th>Show Time</th>
                <th>Seat</th>
                <th>Booking Source</th>
                <th>Customer Name</th>
                <th>Customer Mobile</th>
                <th>Customer Email</th>
                <th>{{ $tc("revenue") }}</th>
                <th>Transaction Date & Time</th>
                <th>Payment Mode</th>
                <th>Offer</th>
                <th>Delivery Status</th>
              </tr>
            </thead>

            <tbody
              v-for="(fnbtrans, fnbtransIndex) in transactionList"
              :key="fnbtransIndex"
            >
              <tr>
                <!-- Order code -->
                <td class="mono">
                  {{ fnbtrans.order_code }}
                </td>

                <!-- Order type pill (blue / yellow) -->
                <td>
                  <span
                    class="order-type-pill"
                    :class="{
                      'order-type-pickup':
                        fnbtrans['order_type'] === 'Self Pickup',
                      'order-type-delivery':
                        fnbtrans['order_type'] === 'Seat Delivery'
                    }"
                  >
                    {{ fnbtrans["order_type"] || "-" }}
                  </span>
                </td>

                <!-- Pickup / Delivery time with fallback -->
                <td>
                  <span
                    :class="{
                      'invalid-date':
                        fnbtrans['order_delivery_time'] === 'Invalid date'
                    }"
                  >
                    {{ formatPickupDeliveryTime(fnbtrans) }}
                  </span>
                </td>

                <!-- Cinema -->
                <td>
                  {{ fnbtrans.ft_cinema_name }}
                </td>

                <!-- Screen -->
                <td>
                  {{
                    fnbtrans.body_json && fnbtrans.body_json.seat_drop_screen
                      ? fnbtrans.body_json.seat_drop_screen
                      : "-"
                  }}
                </td>

                <!-- Movie -->
                <td>
                  {{
                    fnbtrans.body_json && fnbtrans.body_json.seat_drop_movie
                      ? fnbtrans.body_json.seat_drop_movie
                      : "-"
                  }}
                </td>

                <!-- Show time -->
                <td>
                  {{
                    fnbtrans.body_json && fnbtrans.body_json.seat_drop_time
                      ? fnbtrans.body_json.seat_drop_time
                      : "-"
                  }}
                </td>

                <!-- Seat -->
                <td>
                  {{
                    fnbtrans.body_json && fnbtrans.body_json.seat_drop_label
                      ? fnbtrans.body_json.seat_drop_label
                      : "-"
                  }}
                </td>
                <td>{{ fnbtrans.fst_booking_source }}</td>
                <td>{{ fnbtrans.customer_name || "-" }}</td>
                <td>{{ fnbtrans.cust_mobile || "-" }}</td>
                <td>{{ fnbtrans.cust_email || "-" }}</td>
                <td class="mono">
                  {{ fnbtrans.ft_total_amount.toFixed(MIN_FRACTION_DIGITS) }}
                </td>
                <td class="mono">
                  {{ dateParse(fnbtrans.ft_date_time) }}
                </td>
                <td>{{ fnbtrans.pm_payment_mode }}</td>
                <td>
                  {{ fnbtrans.ft_offer_name ? fnbtrans.ft_offer_name : "-" }}
                </td>
                <td>
                  <span
                    class="status-text"
                    :class="{
                      'status-green': fnbtrans.fat_status === 'Delivered',
                      'status-orange': fnbtrans.fat_status === 'Pending'
                    }"
                  >
                    {{ fnbtrans.fat_status ? fnbtrans.fat_status : "-" }}
                  </span>
                </td>
              </tr>
            </tbody>

            <!-- Total Row -->
            <tbody v-if="transactionList.length > 0" class="total-row">
              <tr>
                <td colspan="12" class="total-label">Total</td>
                <td class="mono total-amount">
                  {{ totalAmount.toFixed(MIN_FRACTION_DIGITS) }}
                </td>
                <td colspan="4"></td>
              </tr>
            </tbody>

            <tbody>
              <tr>
                <td v-if="transactionList.length == 0" colspan="18">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import PosFnbService from "@/services/PosFnbService";
import MasterService from "@/services/MasterService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      dropDown: {
        cinemas: [],
        selectedCinema: [],
        selectedCinemaName: null,
        selectedCinemaId: ""
      },
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      transactionList: [],
      selectedCinema: "",
      cine_id: null,
      Cinemas: [],
      BookingSourceList: [],
      selectedBookingSource: "",
      bs_id: null,
      date: new Date(),
      toDate: new Date(),
      fnbOrderStatus: ["All", "Pending", "Complete", "Delivered"],
      selectedStatus: "Pending",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10"
    };
  },
  computed: {
    totalAmount() {
      return this.transactionList.reduce((sum, item) => {
        return sum + (item.ft_total_amount || 0);
      }, 0);
    }
  },
  beforeMount() {
    this.getviewingnumber();

    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.GetBookingSources();
  },
  watch: {},
  methods: {
    formatPickupDeliveryTime(fnbtrans) {
      if (
        fnbtrans.order_delivery_time &&
        fnbtrans.order_delivery_time !== "Invalid date"
      ) {
        return moment(fnbtrans.order_delivery_time).format("HH:mm DD-MMM");
      }

      const timeToUse = fnbtrans.fnb_pickup_time || fnbtrans.fnb_delivery_time;

      if (timeToUse) {
        return moment(timeToUse).format("HH:mm DD-MMM");
      }

      return "-";
    },
    onChangeDate: function(e, type) {
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaAddress = event.cine_address;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getCinemaList: function() {
      MasterService.GetCinemasByRoles()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        // this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        // this.selectedvalue = event;
        // this.perPage = event;
        // console.log("perPage :", this.perPage);
        // this.onChangePagination();
        const value = parseInt(event, 10);
    this.perPage = isNaN(value) ? 10 : value;
    this.selectedvalue = event;
      }
      this.onChangePagination();
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.GetTransactionList();
      } else {
        this.currentPage = event;
        this.GetTransactionList();
      }
    },
    dateParse(date) {
      return moment(date).format("DD-MMM-YYYY HH:mm");
    },
    toDetails(object) {
      this.$router.push({
        name: "View F&B App Transaction",
        params: { ft_id: object.ft_id }
      });
    },

    GetBookingSources: function() {
      PosFnbService.BookingSources()
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              data.Records.map(x => {
                if (x.bs_id == 7 || x.bs_id == 6)
                  this.BookingSourceList.push(x);
              });
              console.log(
                "this.BookingSourceList :>> ",
                this.BookingSourceList
              );
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    onSelect: function(event, params, type) {
      if (type == "Cinema") {
        this.selectedCinema = params.cine_name;
        this.cine_id = params.cine_id;
        this.searchCinema = "";
        this.onSearchCinema();
        this.$store.dispatch("selectDropdownCinema", params);
      } else if (type == "BookingSource") {
        if (params.bs_source === "All") {
          this.selectedBookingSource = "All";
          this.bs_id = null;
          this.fetchAllBookingSources();
        } else {
          this.selectedBookingSource = params.bs_source;
          this.bs_id = params.bs_source;
          this.fetchBookingSourceData(params.bs_id);
        }
      } else if (type == "OrderStatus") {
        this.selectedStatus = params;
      }
    },
    GetTransactionList: function(isExcel = "N", isPdf = "N") {
      let role_is_cinema_level = this.secureStore.get("USINFO").cinema_id;

      if (role_is_cinema_level && !this.dropDown.selectedCinema.length) {
        return this.$toasted.show("Select Cinema");
      }

      let loader = this.$loading.show();
      let selectedCinemaNames = this.dropDown.selectedCinema.map(
        cinemasObj => cinemasObj.cine_name
      );
      let selectedCinemaAddress = this.dropDown.selectedCinema.map(
        cinemasObj => cinemasObj.cine_address
      );
      let payload = {
        cinema_address: selectedCinemaAddress || [],
        cinema_name:
          selectedCinemaNames || this.dropDown.selectedCinemaName || "",
        cinema_id: this.dropDown.selectedCinema.length
          ? this.dropDown.selectedCinema.map(cinemasObj => cinemasObj.cine_id)
          : this.cine_id
          ? [this.cine_id]
          : [],
        limit: this.perPage,
        currentPage: this.currentPage,
        date: moment(this.date).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        bs_id: this.bs_id,
        selectedStatus: this.selectedStatus,
        isPdf,
        isExcel
      };

      PosFnbService.GetFnBAppTransactions(payload)
        .then(response => {
          this.btenable = false;
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.transactionList = data.Records.sort((a, b) => {
                if (a.ft_cinema_name < b.ft_cinema_name) {
                  return -1;
                } else if (a.ft_cinema_name > b.ft_cinema_name) {
                  return 1;
                }

                return 0;
              });

              this.transactionList.forEach(elem => {
                return (elem["body_json"] = elem["body_json"]
                  ? JSON.parse(elem["body_json"])
                  : {});
              });

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue =
                  this.selectedvalue < 10 ? 10 : this.selectedvalue;
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.transactionList = [];
              this.$toasted.show("No Records Found");
            }
          } else {
            this.transactionList = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    }
  }
};
</script>

<style scoped>
.swc-report {
  margin-top: 16px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 10px;
}

.swc-report-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  overflow-x: auto;
  border: none !important;
}

.swc-report-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  font-size: 13px;
  border: none !important;
}

.swc-report-table thead tr {
  background: #f4f6fb;
}

.swc-report-table th {
  padding: 12px 20px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  color: #4b5563;
  white-space: nowrap;
  border-bottom: 1px solid #e5e7eb;
}

.swc-report-table td {
  padding: 12px 20px;
  border-bottom: 1px solid #edf1f7;
  color: #111827;
  vertical-align: middle;
  text-align: left;
}

/* Right align for numeric columns */
.swc-report-table td.mono,
.swc-report-table th:nth-child(13),
.swc-report-table td:nth-child(13),
.swc-report-table th:nth-child(14),
.swc-report-table td:nth-child(14) {
  text-align: right;
}

.swc-report-table tbody tr:last-child td {
  border-bottom-color: #f3f4f6;
}

.swc-report-table tbody tr:hover {
  background: #f9fafb;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
}

.order-type-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
}

.order-type-pickup {
  background: #e0edff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.order-type-delivery {
  background: #fff5d9;
  border-color: #facc15;
  color: #92400e;
}

.invalid-date {
  color: #9ca3af;
  font-style: italic;
}

.status-text {
  font-size: 12px;
  font-weight: 600;
}

.status-green {
  color: #16a34a !important;
  border-left: none !important;
}

.status-orange {
  color: #d97706 !important;
}

.text-green {
  color: #16a34a;
}

.text-red {
  color: #dc2626;
}

.total-row tr {
  background: #f8fafc;
  border-top: 2px solid #cbd5e1;
  font-weight: 600;
}

.total-row tr:hover {
  background: #f8fafc !important;
}

.total-label {
  font-weight: 700;
  color: #1e293b;
  font-size: 14px;
  text-align: left;
}

.total-amount {
  font-weight: 700;
  color: #1e293b;
  font-size: 14px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBOrdersComponent/FnbOrders.vue